import { render, staticRenderFns } from "./financeiro-tabela-regras-produtividade.vue?vue&type=template&id=b0086944&scoped=true"
import script from "./financeiro-tabela-regras-produtividade.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-regras-produtividade.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-regras-produtividade.vue?vue&type=style&index=0&id=b0086944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0086944",
  null
  
)

export default component.exports